import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';

const UserMenu = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { isLoggedIn, logout } = useAuth();
  const closeTimeoutRef = useRef(null);
  const containerRef = useRef(null);

  const handleLogout = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    console.log('UserMenu: Logging out...');
    
    // Logout is now synchronous (clears state immediately)
    // signOut runs in background
    logout();
    
    // Small delay to ensure state updates propagate
    await new Promise(resolve => setTimeout(resolve, 100));
    
    console.log('UserMenu: Navigating to home...');
    navigate('/', { replace: true });
  };

  const handleMouseEnter = () => {
    // Clear any pending close timeout
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
    setOpen(true);
  };

  const handleMouseLeave = () => {
    // Add a small delay before closing to allow mouse movement
    closeTimeoutRef.current = setTimeout(() => {
      setOpen(false);
    }, 150);
  };

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
    };
  }, []);

  if (!isLoggedIn) return null;

  return (
    <div 
      ref={containerRef}
      style={{ position: 'relative', display: 'inline-block' }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        style={{
          background: 'rgba(255,255,255,0.08)',
          border: 'none',
          borderRadius: '50%',
          width: 40,
          height: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '0 2px 8px 0 rgba(0,0,0,0.10)',
          transition: 'background 0.2s',
        }}
        aria-label="User menu"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="8" r="4" />
          <path d="M4 20c0-2.2 3.6-4 8-4s8 1.8 8 4" />
        </svg>
      </button>
      {open && (
        <div 
          style={{
            position: 'absolute',
            right: 0,
            top: 'calc(100% + 8px)',
            background: 'rgba(15,23,42,0.98)',
            borderRadius: 12,
            boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
            minWidth: 160,
            zIndex: 100,
            padding: '0.5rem 0',
            pointerEvents: 'auto',
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <button
            style={{
              width: '100%',
              background: 'none',
              border: 'none',
              color: '#b6c6e3',
              fontSize: '1rem',
              padding: '0.7rem 1.5rem',
              textAlign: 'left',
              cursor: 'pointer',
              transition: 'background 0.2s',
            }}
            onClick={() => { setOpen(false); navigate('/profile'); }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
              if (closeTimeoutRef.current) {
                clearTimeout(closeTimeoutRef.current);
                closeTimeoutRef.current = null;
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'none';
            }}
          >
            Profile
          </button>
          <button
            style={{
              width: '100%',
              background: 'none',
              border: 'none',
              color: '#ef4444',
              fontSize: '1rem',
              padding: '0.7rem 1.5rem',
              textAlign: 'left',
              cursor: 'pointer',
              transition: 'background 0.2s',
            }}
            onClick={handleLogout}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(239,68,68,0.1)';
              if (closeTimeoutRef.current) {
                clearTimeout(closeTimeoutRef.current);
                closeTimeoutRef.current = null;
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'none';
            }}
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu; 